import { render, staticRenderFns } from "./HeaderIconsDropdownCart.vue?vue&type=template&id=3c0ef465&scoped=true&"
import script from "./HeaderIconsDropdownCart.vue?vue&type=script&lang=js&"
export * from "./HeaderIconsDropdownCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ef465",
  null
  
)

export default component.exports